module.exports = __webpack_public_path__ + "6149020ccf1574d8f6437fdc8c668f87.png";